import {
    getApolloErrorUiMessage,
    useRolloverSubscriptionMutation,
    useSkipTrialSubscriptionMutation,
} from '@lingoda/monolith-graphql';
import { trans } from '@lingoda/i18n';
import { showErrorToast } from '@lingoda/toasts';
import { type DialogConfirmProps } from '@lingoda/ui';
import { ConfirmRolloverDialog } from './ConfirmRolloverDialog';
import ConfirmRolloverTrialDialog from './ConfirmRolloverTrialDialog';

interface RolloverSubscriptionDialogProps extends ConfirmDialogProps {
    isInTrial?: boolean;
    isRecurring: boolean;
    price: string;
    onSuccess?: () => void;
}

type ConfirmDialogProps = Pick<DialogConfirmProps, 'isOpen' | 'onDismiss'>;

export const RolloverSubscriptionDialog = ({
    isOpen,
    onDismiss,
    onSuccess,
    isInTrial,
    isRecurring,
    price,
}: RolloverSubscriptionDialogProps) => {
    const [skipTrial, { loading: isSkipTrialLoading }] = useSkipTrialSubscriptionMutation({
        onError(error) {
            showErrorToast(getApolloErrorUiMessage(error) || trans('masked-error', {}, 'errors'));
        },
        onCompleted: () => onSuccess?.(),
    });

    const [rolloverSubscription, { loading: isRolloverSubscriptionLoading }] =
        useRolloverSubscriptionMutation({
            onError(error) {
                showErrorToast(
                    getApolloErrorUiMessage(error) || trans('masked-error', {}, 'errors'),
                );
            },
            onCompleted: onSuccess,
        });

    const isLoading = isSkipTrialLoading || isRolloverSubscriptionLoading;

    const commonProps = {
        onDismiss,
        isOpen,
        confirmStatus: isLoading ? 'loading' : 'enabled',
        onConfirm: isInTrial ? skipTrial : rolloverSubscription,
    } as const;

    return isInTrial ? (
        <ConfirmRolloverTrialDialog {...commonProps} />
    ) : (
        <ConfirmRolloverDialog
            {...commonProps}
            price={price}
            isRecurringSubscription={isRecurring}
        />
    );
};
